import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { AdaptiveSelect } from '../../AdaptiveSelect/AdaptiveSelect';
import { MUSCLE_GROUPS, EXERCISE_CATEGORIES } from '../../../types/Fisiofit/fisiofitConst';

interface ExerciseFiltersProps {
  selectedExerciseMuscleGroups: MUSCLE_GROUPS[];
  setSelectedExerciseMuscleGroups: Dispatch<SetStateAction<MUSCLE_GROUPS[]>>;
  selectedExerciseCategories: EXERCISE_CATEGORIES[];
  setSelectedExerciseCategories: Dispatch<SetStateAction<EXERCISE_CATEGORIES[]>>;
}

export const ExerciseFilters = ({
  selectedExerciseMuscleGroups,
  setSelectedExerciseMuscleGroups,
  selectedExerciseCategories,
  setSelectedExerciseCategories,
}: ExerciseFiltersProps) => {
  const exerciseMuscleGroupOptions = useMemo(() => {
    return Object.values(MUSCLE_GROUPS).map((group) => ({ label: group, value: group }));
  }, []);

  const exerciseCategoryOptions = useMemo(() => {
    return Object.values(EXERCISE_CATEGORIES).map((category) => ({ label: category, value: category }));
  }, []);
  return (
    <div className='exercise-days-filters'>
      <div className='exercise-days-muscle-groups-filter'>
        <small>Filtrar por grupos musculares:</small>
        <AdaptiveSelect
          value={selectedExerciseMuscleGroups}
          options={exerciseMuscleGroupOptions}
          onChange={(value) => setSelectedExerciseMuscleGroups(value)}
          placeholder='Grupos musculares'
          modalTitle='Seleccionar grupos musculares'
          searchPlaceholder='Grupos musculares'
          emptyMessage='No hay grupos musculares'
          emptyFilterMessage='No se han encontrado grupos musculares'
          isMultiple={true}
          itemTemplate={(option) => <span>{option.label}</span>}
        />
      </div>
      <div className='exercise-days-categories-filter'>
        <small>Filtrar por categorías:</small>
        <AdaptiveSelect
          value={selectedExerciseCategories}
          options={exerciseCategoryOptions}
          onChange={(value) => setSelectedExerciseCategories(value)}
          placeholder='Categorías'
          modalTitle='Seleccionar categorías'
          searchPlaceholder='Categorías'
          emptyMessage='No hay categorías'
          emptyFilterMessage='No se han encontrado categorías'
          isMultiple={true}
          itemTemplate={(option) => <span>{option.label}</span>}
        />
      </div>
    </div>
  );
};
